import { render, staticRenderFns } from "./CorporationL.vue?vue&type=template&id=b3a561ae&scoped=true"
import script from "./CorporationL.vue?vue&type=script&lang=js"
export * from "./CorporationL.vue?vue&type=script&lang=js"
import style0 from "./CorporationL.vue?vue&type=style&index=0&id=b3a561ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a561ae",
  null
  
)

export default component.exports